import { createColumnHelper } from '@tanstack/react-table';

import { Contact } from 'types/user';

const col = createColumnHelper<Contact>();

export const buildCustomerContactColumns = () => [
  col.accessor((contact) => `${contact?.fname || ''} ${contact?.lname || ''}`, {
    id: 'fullName',
    header: 'Full Name',
    minSize: 150,
    size: 170,
  }),
  col.accessor((contact) => contact?.role || '', {
    id: 'role',
    header: 'Role',
    minSize: 100,
    size: 120,
  }),
  col.accessor((contact) => contact?.email, {
    id: 'email',
    header: 'Email',
    minSize: 200,
    size: 300,
  }),
  col.accessor((contact) => contact?.phone || '', {
    id: 'phone',
    header: 'Phone Number',
    minSize: 120,
    size: 120,
  }),
];
